import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { connect } from 'react-redux';
import * as actions from 'auth/redux';
import { UserProp } from 'auth';
import Button, { btnThemes } from 'components/button';
import Modal, { Content, Header } from 'components/modal';
import Form, { Input } from 'containers/form';
import Row, { Col } from 'components/row';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';
import 'styles/forum/common/_investor-registry.scss';

const bemClassesAdminPane = new Bem('adminPanelForum');
const classesBemForm = new Bem('modalContentAdmin');

@connect(state => ({
  auth: state.auth
}), { ...actions })
export default class AddForumNick extends Component {
  static propTypes = {
    auth: UserProp,
    functionIsLogin: PropTypes.func,
    onCloseModalForumNick: PropTypes.func
  };

  onSubmit =()=> {
    if (typeof this.props.actionAuthGetData === 'function') this.props.actionAuthGetData();
    this.modal.close();
    if (typeof this.props.functionIsLogin === 'function') this.props.functionIsLogin();
  }

  render () {
    const { auth, onCloseModalForumNick } = this.props;

    if (!auth.data.authenticated || auth.data.forum_nick) return null;

    return (
      <Modal
        {...bemClassesAdminPane('modal', 'addNick')}
        ref={el => this.modal = el}
        onCloseRequired={onCloseModalForumNick}
        renderModal
        size="big"
      >
        <Header closeButton children="Добавление Ника на форуме" />
        <Content>
          <div {...classesBemForm()}>
            <Form
              {...classesBemForm('flexColumn')}
              controller="user/forum/forum-nick"
              entityId={this.props.auth.data.id}
              onSubmit={this.onSubmit}
              hFull
            >
              <Row style={{ paddingTop: '2.5rem' }}>
                <Col allPr={0}>
                  <Input
                    dataBind="forum_nick"
                    autoFocus
                  />
                </Col>
              </Row>
              <div {...classesBemForm('footer')}>
                <Row {...classesBemForm('btnsContainer')} allJustifyCFlexEnd>
                  <Col allAuto allPr={0}>
                    <Button
                      type="submit"
                      label="Cохранить"
                      theme={btnThemes.sky}
                      big
                    />
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
        </Content>
      </Modal>
    )
  };
}
